var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 114,
    viewBox: "0 0 211 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1504_10857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.157 6.04628C26.157 6.04628 93.964 3.51864 103.53 6.04628C111.955 8.28085 135.023 26.597 135.023 26.597L92.8234 76.0508C92.8234 76.0508 57.945 63.4492 52.3158 60.9216C46.6867 58.394 38.2614 50.8477 38.2614 50.8477H26.157V6.00965V6.04628Z",
    fill: "#C77812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9635 44.9122L67.1445 66.6719C60.3749 64.1442 54.3778 61.873 52.3175 60.9572C46.6884 58.4296 38.2631 50.8833 38.2631 50.8833H26.1586V31.5414H38.815L60.9635 44.9122Z",
    fill: "#8C4306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.883 35.7174V111.363H57.3954V35.7174H200.883Z",
    fill: "#3A7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.883 38.3541V114H57.3954V38.3541H200.883Z",
    fill: "#56B512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.139 55.1687C117.476 55.1687 108.021 64.5832 108.021 76.1957C108.021 87.8081 117.476 97.2227 129.139 97.2227C140.802 97.2227 150.258 87.8081 150.258 76.1957C150.258 64.5832 140.802 55.1687 129.139 55.1687Z",
    fill: "#4A9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.628 76.1956C161.628 70.632 166.158 66.1217 171.746 66.1217C177.333 66.1217 181.863 70.632 181.863 76.1956C181.863 81.7593 177.333 86.2695 171.746 86.2695C166.158 86.2695 161.628 81.7593 161.628 76.1956Z",
    fill: "#80D52F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3818 76.1956C76.3818 70.632 80.9116 66.1217 86.4995 66.1217C92.0873 66.1217 96.6172 70.632 96.6172 76.1956C96.6172 81.7593 92.0873 86.2695 86.4995 86.2695C80.9116 86.2695 76.3818 81.7593 76.3818 76.1956Z",
    fill: "#80D52F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.883 114H57.3954V38.3541H200.883V114ZM61.6265 42.3837V109.97H196.652V42.4203H61.5897L61.6265 42.3837Z",
    fill: "#4A9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.816 94.8779C200.184 94.8779 200.515 94.9512 200.883 94.9878V114H180.059C180.39 103.377 189.109 94.8779 199.816 94.8779Z",
    fill: "#4A9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.059 38.3545H200.883V57.3667C200.515 57.3667 200.184 57.4766 199.816 57.4766C189.073 57.4766 180.39 48.9779 180.059 38.3545Z",
    fill: "#4A9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4265 94.8779C69.1696 94.8779 77.8525 103.377 78.1836 114H57.3595V94.9878C57.7274 94.9878 58.0586 94.8779 58.4265 94.8779Z",
    fill: "#4A9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4265 57.4766C58.0586 57.4766 57.7274 57.4033 57.3595 57.3667V38.3545H78.1836C77.8525 48.9779 69.1328 57.4766 58.4265 57.4766Z",
    fill: "#4A9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.855 69.8952C132.855 70.8843 132.561 71.6536 132.009 72.2397C131.457 72.8258 130.464 73.3753 129.029 73.9248C126.343 74.8406 124.356 75.8663 123.069 77.0752C121.781 78.284 121.119 79.9325 121.119 82.0938C121.119 84.0719 121.781 85.7204 123.069 87.0025C124.356 88.2847 126.122 89.0173 128.33 89.2371V93.0469H131.163V89.2005C133.297 88.9074 134.952 88.0649 136.167 86.7095C137.381 85.3541 137.969 83.5591 137.933 81.3978V81.2879H132.819C132.819 82.57 132.524 83.5591 131.936 84.2551C131.347 84.9511 130.537 85.2808 129.471 85.2808C128.367 85.2808 127.557 84.9877 127.042 84.4016C126.527 83.8155 126.306 83.0462 126.306 82.0572C126.306 81.1413 126.564 80.4087 127.116 79.8592C127.631 79.3097 128.661 78.7236 130.17 78.1009C132.819 77.2583 134.769 76.196 136.093 74.9871C137.381 73.7416 138.043 72.0565 138.043 69.8952C138.043 67.7339 137.418 66.1953 136.093 64.9498C134.805 63.7043 133.039 62.9717 130.832 62.7519V59.2718H127.999V62.7519C125.718 62.9717 123.841 63.7043 122.37 65.0231C120.898 66.3419 120.199 68.2467 120.236 70.7744V70.8843H125.35C125.35 69.3823 125.718 68.2834 126.454 67.6606C127.189 67.0012 128.146 66.7082 129.36 66.7082C130.574 66.7082 131.384 67.0012 131.972 67.5507C132.561 68.1002 132.855 68.9061 132.855 69.8586V69.8952Z",
    fill: "#80D52F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 25.6432V101.289H67.5126V25.6432H211Z",
    fill: "#398E01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 28.2799V103.926H67.5126V28.2799H211Z",
    fill: "#63C21F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.257 45.0945C127.594 45.0945 118.138 54.509 118.138 66.1214C118.138 77.7339 127.594 87.1484 139.257 87.1484C150.92 87.1484 160.375 77.7339 160.375 66.1214C160.375 54.509 150.92 45.0945 139.257 45.0945Z",
    fill: "#57A812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.898 56.0123C176.306 56.0123 171.78 60.5181 171.78 66.0862C171.78 71.6544 176.306 76.1602 181.898 76.1602C187.49 76.1602 192.016 71.6544 192.016 66.0862C192.016 60.5181 187.49 56.0123 181.898 56.0123Z",
    fill: "#8DE23C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6167 56.0123C91.0243 56.0123 86.499 60.5181 86.499 66.0862C86.499 71.6544 91.0243 76.1602 96.6167 76.1602C102.209 76.1602 106.734 71.6544 106.734 66.0862C106.734 60.5181 102.209 56.0123 96.6167 56.0123Z",
    fill: "#8DE23C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 103.926H67.5126V28.2799H211V103.926ZM71.7437 32.3095V99.8596H206.769V32.3095H71.7069H71.7437Z",
    fill: "#57A812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.933 84.8037C210.301 84.8037 210.632 84.8769 211 84.9136V103.926H190.176C190.507 93.3024 199.227 84.8037 209.933 84.8037Z",
    fill: "#57A812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.176 28.2802H211V47.2925C210.632 47.2925 210.301 47.4023 209.933 47.4023C199.19 47.4023 190.507 38.9036 190.176 28.2802Z",
    fill: "#57A812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5788 84.8037C79.322 84.8037 88.0048 93.3024 88.3359 103.926H67.5119V84.9136C67.8798 84.9136 68.2109 84.8037 68.5788 84.8037Z",
    fill: "#57A812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5788 47.4023C68.2109 47.4023 67.8798 47.3291 67.5119 47.2925V28.2802H88.3359C88.0048 38.9036 79.2852 47.4023 68.5788 47.4023Z",
    fill: "#57A812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8611 21.431C81.8611 21.431 113.097 56.1585 114.79 60.9207C116.482 65.6829 113.024 71.1778 106.18 69.2729C99.3371 67.368 91.3165 54.217 84.3997 50.4072C77.5197 46.6341 47.277 50.4072 38.8149 31.5049L39.3667 23.9586L81.8611 21.431Z",
    fill: "#C77812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0469 2.12479V55.0586H10.9285V2.12479H32.0469Z",
    fill: "#EFDFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.082 0.00190735V57.1484H-0.0363712V0.00190735H21.082Z",
    fill: "#282E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5217 39.0866C8.49815 39.0866 6.87932 40.7351 6.87932 42.7132C6.87932 44.6914 8.53494 46.3398 10.5217 46.3398C12.5084 46.3398 14.1641 44.6914 14.1641 42.7132C14.1641 40.7351 12.5084 39.0866 10.5217 39.0866Z",
    fill: "#EFDFEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1504_10857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 211,
    fill: "white",
    transform: "matrix(0 -1 -1 0 211 114)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.b0b2826fda53865784892cb5afbebc6f.svg";
export { ForwardRef as ReactComponent };